<template>
  <WdsStack v-if="totalClients > 0" direction-row align-center gap-xs wrap>
    <WdsTag v-for="link in visibleClients" :key="link.id" sm data-test="end-client-tag">
      {{ link.client.name }}
    </WdsTag>
    <WdsTooltip v-if="hiddenCount > 0" global placement="top">
      <WdsTag sm data-test="end-client-tag-more">+{{ hiddenCount }}</WdsTag>
      <template #tooltip-content>
        <div v-for="link in hiddenClients" :key="link.id">{{ link.client.name }}</div>
        <div v-if="hiddenCount > hiddenClients.length">
          {{ $t('and :count more', { count: hiddenCount - hiddenClients.length }) }}
        </div>
      </template>
    </WdsTooltip>
  </WdsStack>
  <WdsText v-else secondary>—</WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsStack, WdsTag, WdsText, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

// An MSP agency can serve dozens of clients; the row has to stay one row.
const VISIBLE_LIMIT = 2

const CompanyRecruiterEndClientsColumn = graphql(`
  fragment CompanyRecruiterEndClientsColumn on CompanyRecruiter {
    id
    endClients(first: 100) {
      data {
        id
        client {
          id
          name
        }
      }
      paginatorInfo {
        total
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof CompanyRecruiterEndClientsColumn>
}>()

const column = computed(() => useFragment(CompanyRecruiterEndClientsColumn, props.row))
const totalClients = computed(() => column.value.endClients.paginatorInfo.total)
const visibleClients = computed(() => column.value.endClients.data.slice(0, VISIBLE_LIMIT))
const hiddenClients = computed(() => column.value.endClients.data.slice(VISIBLE_LIMIT))
const hiddenCount = computed(() => totalClients.value - visibleClients.value.length)
</script>
